import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IOrganization } from '@/shared/model/organization.model';
import { ResourceInterface } from '@/shared/component/resource.interface';
import { SERVER_API_URL, TOKEN } from '@/constants';

const baseApiUrl = 'api/private/organizations';

export default class OrganizationService implements ResourceInterface {
  public find(id: number): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${Number(id)}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieveSso(name?: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`api/public/organizations/sso?name=${encodeURIComponent(name)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieveSsoByDomainName(name?: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`api/public/organizations/sso/domain?name=${encodeURIComponent(name)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public export(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/export?${buildPaginationQueryOpts(paginationQuery)}`,  {responseType: 'blob'})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IOrganization): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IOrganization): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public resellerUpdate(entities: IOrganization[]): Promise<IOrganization> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/reseller/import`, entities)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getOwner(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/owner`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getHybridScormViewerCount(dto: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.post(baseApiUrl + '/hybrid-scorm/count', dto)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }

  public getHybridScormViewer(dto: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.post(baseApiUrl + '/hybrid-scorm', dto)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }

  public getCVRViewer(dto: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.post(baseApiUrl + '/cvr/viewers', dto)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }


  public getAllHybridScormViewerCount(dto: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.post(baseApiUrl + '/hybrid-scorm/all', dto)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }


  public getSubscriptionsCount(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/subscriptions/count`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public isTTADomainAvailable(name: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/tta-domain`, { domain: name })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieveOrgProducts(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/${id}/products`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieveOrgDisabledProducts(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/${id}/disabled-products`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public disableOrgProduct(orgId: number, productId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/${orgId}/disabled-products/${productId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public enableOrgProduct(orgId: number, productId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${orgId}/disabled-products/${productId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getTrialRules(orgId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${orgId}/trial-policies`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public disableTrial(orgId: number, flag: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const body = {
        defaultTrialEnabled: flag,
      };
      axios
        .put(`${baseApiUrl}/${orgId}/trial-policies`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public addAllowedPlans(organizationId: number, planIds: number[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`api/private/resellers/${organizationId}/plans`, planIds)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public removeAllowedPlan(organizationId: number, planId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/private/resellers/${organizationId}/plans/${planId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public fetchAllowedPlans(organizationId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`api/private/resellers/${organizationId}/plans`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public removeAllAllowedPlans(organizationId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/private/resellers/${organizationId}/plans`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public syncHubspot(organizationId: number, callbacks?: {
    onMessage?: (data: any) => void;
    onError?: (error: any) => void;
    onComplete?: () => void;
  }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);
      const url = `${SERVER_API_URL}api/private/admin/organizations/partners/hubspot-sync/${organizationId}`;

      const headers: HeadersInit = {
        'Accept': 'text/event-stream',
        'Cache-Control': 'no-cache',
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      fetch(url, {
        method: 'PUT',
        headers,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          if (!response.body) {
            throw new Error('Response body is null');
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';

          // eslint-disable-next-line arrow-body-style
          const processStream = (): Promise<void> => reader.read().then(({ done, value }) => {
              if (done) {
                if (callbacks?.onComplete) {
                  callbacks.onComplete();
                }
                resolve({ completed: true });
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split('\n');
              buffer = lines.pop() || ''; // Keep incomplete line in buffer

              for (const line of lines) {
                if (line.startsWith('id:')) {
                  // Event ID can be used for reconnection scenarios if needed
                } else if (line.startsWith('event:')) {
                  // Event type can be handled here if needed
                } else if (line.startsWith('data:')) {
                  const data = line.substring(5).trim();
                  if (data) {
                    try {
                      const parsedData = JSON.parse(data);
                      if (callbacks?.onMessage) {
                        callbacks.onMessage(parsedData);
                      }
                    } catch (e) {
                      // If not JSON, pass as string
                      if (callbacks?.onMessage) {
                        callbacks.onMessage(data);
                      }
                    }
                  }
                }
              }

              return processStream();
            });

          return processStream();
        })
        .catch((error) => {
          if (callbacks?.onError) {
            callbacks.onError(error);
          }
          reject(error);
        });
    });
  }
}
